import { Button } from "@mui/material"


function CoordsButton({title, output, styles, color}){

    if (!navigator.geolocation) {
        title = `Your browser doesn't support Geolocation`;
        // message.classList.add('error');
    }

    // handle success case
    function onSuccess(position) {
        const {
            latitude,
            longitude
        } = position.coords;
        output(latitude + ", " + longitude)
        console.log(latitude);
        console.log(longitude);
        // //getStreetName({ latitude, longitude });
        // console.log(position.coords)
        // fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=es`)
        //     .then((response) => response.json())
        //     .then((maps) =>
        //         message.textContent = `Your location: (${latitude},${longitude})` + "\nUbicación: " + maps.locality + ',' + maps.city);
    }

    // handle error case
    function onError() {
        // message.classList.add('error');
        // message.textContent = `Failed to get your location!`;
    }

const getCoords = () => {
    navigator.geolocation.getCurrentPosition(onSuccess, onError);
}
    return(
        <>
        <Button onClick={getCoords} sx={styles} color={color}>
            {title}
        </Button>
        </>
    )
}
export {CoordsButton}